import { MINERALS_ACTIONS } from './MINERALS_ACTIONS'

export function mineralsReducer(state, action) {
  switch (action.type) {
    case MINERALS_ACTIONS.SET_MINERALS:
      return {
        ...state,
        minerals: action.payload.minerals,
        pagination: action.payload.pagination,
      }
    case MINERALS_ACTIONS.SET_IS_LOADING:
      return { ...state, isLoading: action.payload.isLoading }
    default:
      return state
  }
}
